/* eslint-disable react/prop-types */
import { useEventCallback, useMediaQuery } from 'usehooks-ts'

import { CountdownTimer } from '@wwt/ui/components'

import { useToast } from '@/shared/lib/hooks/useToast'
import {
	Toast,
	ToastClose,
	ToastDescription,
	ToastProvider,
	ToastTitle,
	ToastViewport
} from '@/shared/ui/Toast'

export interface ToasterProps {
	activeLayers?: string[]
	children?: React.ReactNode
}

export const Toaster = ({ activeLayers, children }: ToasterProps) => {
	const { toasts } = useToast()

	const mobile = useMediaQuery('(width < 640px)')

	const handleSwipe = useEventCallback((e: Event) => e.preventDefault())

	return (
		<ToastProvider swipeDirection={mobile ? 'down' : 'left'}>
			{children}
			{toasts
				.filter(toast => {
					if (activeLayers?.length) {
						if (!toast.layer) return false
						return activeLayers.includes(toast.layer)
					}

					return true
				})
				.map(
					({
						id,
						custom,
						title,
						description,
						action,
						swipeCanceled,
						duration = 5000,
						...props
					}) => {
						return (
							<Toast
								key={id}
								onSwipeStart={swipeCanceled ? undefined : handleSwipe}
								onSwipeMove={swipeCanceled ? undefined : handleSwipe}
								onSwipeEnd={swipeCanceled ? undefined : handleSwipe}
								duration={duration}
								{...props}
							>
								{custom ?? (
									<>
										{/* If duration is infinity don't show the timer */}
										{Number.isFinite(duration) && (
											<CountdownTimer
												className="self-start"
												max={duration / 1000}
												isStopped={!props.open}
											/>
										)}
										<div className="grid gap-1">
											{title && <ToastTitle>{title}</ToastTitle>}
											{description && (
												<ToastDescription>{description}</ToastDescription>
											)}
										</div>
										{action}
										<ToastClose />
									</>
								)}
							</Toast>
						)
					}
				)}
			<ToastViewport />
		</ToastProvider>
	)
}
